import { GraphQLClient, gql } from 'graphql-request';

const config = {
    graphQlUrl: location.hostname !== 'localhost' ? `https://editello.com/graphql` : 'http://localhost:8082/graphql',
}

export default {
    getDetails,
};

async function getDetails() {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      {
        app {
            id,
            name,
            description,
            domain,
            photo,
            email,
            phone,
            street,
            city,
            zipcode
        }
      }
    `

    const data = await graphQLClient.request(query)

    return data.app
}